import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { IconInline, Title } from '@omnilert/components'

import classNames from 'classnames'

import useStyles from './contacts-list.style'

const ContactsList = ({ contacts, className }) => {
  const classes = useStyles()

  const getClasses = useMemo(() => {
    const listClasses = [classes.baseList]

    return classNames(listClasses, { [className]: !!className })
  }, [className, classes.baseList])

  return (
    <ul className={getClasses}>
      {contacts.map(({ internationalNumber }, i) => (
        <li
          key={`number-${internationalNumber}-${i}`}
          className={classes.listItem}
        >
          <IconInline
            className={classes.icon}
            name='avatar'
            size={32}
          />
          <Title
            color='var(--tips__text)'
            size='xs'
          >{`${internationalNumber} (SMS)`}
          </Title>
        </li>
      ))}
    </ul>)
}

ContactsList.propTypes = {
  contacts: PropTypes.array.isRequired
}

export default ContactsList
